<template>
  <div class="skusettings-page">
    <h1>{{ $t('SidebarMenu.Menu88') }}</h1>
    <div class="skusettings-body">
      <div class="skusettings-body-top">
        <el-row>
          <el-col :span="12">
            <h3 style="font-size: 16px; margin: 0; line-height: 28px; font-weight: normal;">{{ taskname }}</h3>
            <el-select v-if="false" v-model="taskid" @change="getBaseinfo()" size="mini">
              <el-option 
                v-for="item in priceinfo" 
                :key="item.taskid" 
                :label="item.name" 
                :value="item.taskid"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="skusetting-top-button-group">
            <el-button v-if="isdel == 0" type="primary" size="mini" @click="showDialog" icon="el-icon-document-add">新增 SKU</el-button>
            <el-dropdown size="medium" v-if="isdel == 0" trigger="click" class="dropdownimportbtn">
              <el-button type="primary" size="mini" icon="el-icon-upload">批量导入</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button type="text" size="mini" @click="downloadImportTemplate">下载模板</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button type="text" size="mini" @click="showImportDialog">立即导入</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="info" v-if="isdel == 0" size="mini" @click="getDel" icon="el-icon-delete">回收站</el-button>
            <el-button v-if="isdel == 1" type="primary" size="mini" @click="getSku" icon="el-icon-tickets">返回SKU 列表</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="baseinfo-list">
        <el-table :data="baseinfo" size="mini">
          <el-table-column label="SKUID" prop="SKUID" width="120"></el-table-column>
          <el-table-column label="系列" prop="SKUSeries"></el-table-column>
          <el-table-column label="商品名称" prop="SKUName" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="型号" prop="SKUModel"></el-table-column>
          <el-table-column label="参数" prop="SKUSpec"></el-table-column>
          <el-table-column label="用户SKU code" prop="UserSKUCode" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="常规监测价" prop="price" width="100" align="right"></el-table-column>
          <el-table-column label="操作" width="150" header-align="center" align="center">
            <template slot-scope="set">
              <el-button v-if="isdel == 0 && set.row.SKUSeries != '系统专用/For system use'" type="primary" size="mini" @click="updateSku(set.row)" style="margin-right: 10px;">修改</el-button>
              <el-popconfirm v-if="isdel == 0 && set.row.SKUSeries != '系统专用/For system use'" title="确定删除？" @confirm="deleteSku(set.row.SKUID, 1)">
                <el-button type="danger" plain slot="reference" size="mini">删除</el-button>
              </el-popconfirm>
              <el-popconfirm v-if="isdel == 1 && set.row.SKUSeries != '系统专用/For system use'" title="确定恢复？" @confirm="deleteSku(set.row.SKUID, 0)">
                <el-button type="danger" plain slot="reference" size="mini">恢复</el-button>
              </el-popconfirm>              
            </template>
          </el-table-column>
        </el-table>
        <div class="pagewrap">
          <el-pagination
            small
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="querypage"
            :page-sizes="[25, 50, 100]"
            :page-size="querysize"
            :total="pagetotal"
            popper-class="pagesizeclass"
            layout="total, prev, pager, next, sizes">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      custom-class="editskulink-datafeedback"
      title="添加SKU"
      :visible.sync="showskudialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <div class="addsku-body">
        <el-form :rules="rules" :model="skuinfo" ref="skuinfo" size="mini" label-width="120px">
          <el-form-item label="商品名" prop="SKUName">
            <el-input v-model="skuinfo.SKUName"></el-input>
          </el-form-item>
          <el-form-item label="商品简介" prop="SKUDesc">
            <el-input v-model="skuinfo.SKUDesc"></el-input>
          </el-form-item>
          <el-form-item label="别名" prop="SKUShortName">
            <el-input v-model="skuinfo.SKUShortName"></el-input>
          </el-form-item>
          <el-form-item label="系列" prop="SKUSeries">
            <el-input v-model="skuinfo.SKUSeries"></el-input>
          </el-form-item>
          <el-form-item label="型号" prop="SKUModel">
            <el-input v-model="skuinfo.SKUModel"></el-input>
          </el-form-item>
          <el-form-item label="参数" prop="SKUSpec">
            <el-input v-model="skuinfo.SKUSpec"></el-input>
          </el-form-item>
          <el-form-item label="用戶SKUCode" prop="UserSKUCode">
            <el-input v-model="skuinfo.UserSKUCode"></el-input>
          </el-form-item>
          <el-form-item label="常规监测价" prop="price">
            <el-input v-model="skuinfo.price"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelDialog('skuinfo')">取消</el-button>
        <el-button type="primary" size="mini" @click="addSku">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      custom-class="skuimport-data"
      title="批量导入"
      :visible.sync="showimport"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="80%">
      <div class="sku-import-body">
        <div class="sku-import-btn">
          <input ref="excel-upload-input" class="upload-input-file" type="file" accept=".xlsx, .xls" @change="handleClick" />
        </div>
        <div class="sku-import-lists">
          <el-table :data="exceldata" size="mini">
            <el-table-column label="用户SKUCode" prop="用户SKUCode/UserSKUCode"></el-table-column>
            <el-table-column label="商品名" prop="商品名称/Product Name"></el-table-column>
            <el-table-column label="别名" prop="别称/简称/代号Alias/nickname/short-name"></el-table-column>
            <el-table-column label="商品简介" prop="商品描述/Product description"></el-table-column>
            <el-table-column label="系列" prop="系列/product line/series"></el-table-column>
            <el-table-column label="型号"></el-table-column>
            <el-table-column label="参数" prop="规格参数（容量、支数、大小)/Specification"></el-table-column>
            <el-table-column label="常规监测价" prop="常规监测价(日常到手价）低于此价格为破价"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelImport">取消</el-button>
        <el-button :disabled="exceldata.length == 0" type="primary" size="mini" @click="uploadExcel">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  data(){
    return{
      subid: this.$route.params.Id,
      taskid: '',
      skuid: '',
      taskname: '',
      priceinfo: JSON.parse(localStorage.getItem("price")).val,
      baseinfo: [],
      querypage: 1,
      querysize: 25,
      pagetotal: 0,
      showskudialog: false,
      showimport: false,
      skuinfo: {
        SKUDesc: '',
        SKUName: '',
        SKUSeries: '',
        SKUModel: '',
        SKUShortName: '',
        SKUSpec: '',
        UserSKUCode: '',
        price: '',
        email: JSON.parse(localStorage.getItem("email")).val
      },
      rules: {
        SKUName: [
          { required: true, message: '请输入商品名', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '常规监测价', trigger: 'blur' }
        ]
      },
      edittype: 0, //0:新增， 1:修改
      isdel: 0,
      exceldata: []
    }
  },

  mounted(){
    this.priceinfo.map(item => {
      if(item.subid == this.subid){
         this.taskid = item.taskid
         this.taskname = item.name
         this.getBaseinfo()
      }
    })
  },

  methods: {
    
    /**
     * 切换每页显示的数目
     */
    handleSizeChange: function(){
      this.query.page = 1
      this.getBaseinfo()
    },

    /**
     * 翻页
     */
    handleCurrentChange: function(){
      this.getBaseinfo()
    },

    /**
     * 获取SKU baseinfo
     */
    getBaseinfo: function(){
      let that = this
      let url = that.API_URL + '/v3/price/monitor/skuBaseInfoList?TaskID=' + that.taskid +
                '&page=' + that.querypage +
                '&size=' + that.querysize +
                '&isDel=' + that.isdel
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          that.baseinfo = data.results[0]
          that.pagetotal = data.results[1][0].Count
        },
        error: function(response) {
          console.log('getTaskdiscounts', response)
        }
      })
    },

    /**
     * 显示弹窗
     */
    showDialog: function(){
      this.showskudialog = true
      this.edittype = 0
    },

    /**
     * 取消弹窗
     */
    cancelDialog: function(refs){
      this.$refs[refs].resetFields()
      this.showskudialog = false
      this.edittype = 0
      this.skuinfo = {
        SKUDesc: '',
        SKUName: '',
        SKUSeries: '',
        SKUModel: '',
        SKUShortName: '',
        SKUSpec: '',
        UserSKUCode: '',
        price: '',
        email: JSON.parse(localStorage.getItem("email")).val
      }      
    },

    /**
     * 添加SKU
     */
    addSku: function(){
      let that = this
      let url = this.edittype == 0 ? 
                that.API_URL + '/v3/price/monitor/addskuBaseInfo' :
                that.API_URL + '/v3/price/monitor/updateskuBaseInfo'
      let _query = that.skuinfo
      if(that.edittype == 0){
        _query.TaskID = that.taskid
      }
      if(that.edittype == 1){
        _query.TaskID = that.taskid
        _query.SKUID = that.skuid
      }
      that.$refs['skuinfo'].validate((valid) => {
        if (valid) {
          $.ajax({
            url: url,
            type: "POST",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            contentType: "application/json",
            data: JSON.stringify(_query),
            success: function() {
              that.$message({
                type: 'success',
                message: that.edittype == 0 ? '新增SKU成功' : '修改SKU成功'
              })
              that.cancelDialog('skuinfo')
              that.getBaseinfo()
            },
            error: function(response) {
              console.log(response)
            }
          })
        } else {
          return false
        }
      })
    },

    /**
     * 修改SKU
     */
    updateSku: function(row){
      this.showskudialog = true
      this.edittype = 1
      this.skuinfo = {
        SKUDesc: row.SKUDesc,
        SKUName: row.SKUName,
        SKUSeries: row.SKUSeries,
        SKUModel: row.SKUModel,
        SKUShortName: row.SKUShortName,
        SKUSpec: row.SKUSpec,
        UserSKUCode: row.UserSKUCode,
        price: row.price,
        email: JSON.parse(localStorage.getItem("email")).val
      }
      this.skuid = row.SKUID
    },

    /**
     * 删除SKU
     */
    deleteSku: function(skuid, del){
      let that = this
      let url = that.API_URL + '/v3/price/monitor/deleteskuBaseInfo?SKUID=' + skuid + '&isDel=' + del
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          if(data.results == 'ok'){
            that.$message({
              type: 'success',
              message: del == 1 ? '删除SKU成功' : '恢复SKU成功'
            })
          } else{
            that.$message({
              type: 'warning',
              message: data.results
            })
          }
          that.getBaseinfo()
        },
        error: function(response) {
          console.log('getTaskdiscounts', response)
        }
      })
    },

    /**
     * 回收站
     */
    getDel: function(){
      this.isdel = 1
      this.getBaseinfo()
    },

    /**
     * 正常SKU
     */
    getSku: function(){
      this.isdel = 0
      this.getBaseinfo()
    },

    /**
     * 下载模板
     */
    downloadImportTemplate: function(){
      let _now = new Date()
      let filename = ''
      this.priceinfo.map(item => {
        if(this.taskid == item.taskid){
          filename = item.name
        }
      })
      let a = document.createElement('a')
      a.download = filename + '_' + this.$moment(_now).format('YYYYMMDDHHmmss') + '.xlsx'
      a.href = '/static/SKUBASEINFO.xlsx'
      $("body").append(a)
      a.click()
      $(a).remove()
    },

    /**
     * 批量上传按钮
     */
    showImportDialog: function(){
      this.showimport = true
    },

    /**
     * 是否Excel
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },

    /**
     * 点击按钮选取Excel文件
     */
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      if (!this.isExcel(rawFile)) {
        this.$message.error('Only supports upload .xlsx, .xls, .csv suffix files')
        return
      }
      this.upload(rawFile)
    },
    
    /**
     * 上传
     */
    upload(rawFile) { 
      this.sheetname = []
      this.tableData = []
      this.$refs['excel-upload-input'].value = null
      this.readerData(rawFile)
    },

    /**
     * 读取Excel
     */
    readerData(rawFile) {
      return new Promise((resolve) => {
        let reader = new FileReader()
        reader.onload = e => {
          let data = e.target.result
          let workbook = XLSX.read(data, { type: 'array' })
          let _sheetname = workbook.SheetNames[0]
          let _worksheet = workbook.Sheets[_sheetname]
          let _results = XLSX.utils.sheet_to_json(_worksheet)
          this.exceldata = _results
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },

    /**
     * 取消上传
     */
    cancelImport: function(){
      this.exceldata = []
      this.showimport = false
    },

    /**
     * 确定上传
     */
    uploadExcel: function(){
      let that = this
      let url = that.API_URL + '/v3/price/monitor/importskuBaseInfo'
      let _lists = this.exceldata
      let _query = []
      for(let i=0; i<_lists.length; i++){
        let _obj = {
          TaskID: that.taskid,
          SKUDesc: _lists[i]['商品描述/Product description'] == undefined ? '' : _lists[i]['商品描述/Product description'],
          SKUName: _lists[i]['商品名称/Product Name'] == undefined ? '' : _lists[i]['商品名称/Product Name'],
          SKUSeries: _lists[i]['系列/product line/series'] == undefined ? '' : _lists[i]['系列/product line/series'],
          SKUModel: _lists[i]['型号/model'] == undefined ? '' : _lists[i]['型号/model'],
          SKUShortName: _lists[i]['别称/简称/代号Alias/nickname/short-name'] == undefined ? '' : _lists[i]['别称/简称/代号Alias/nickname/short-name'],
          SKUSpec: _lists[i]['规格参数（容量、支数、大小)/Specification'] == undefined ? '' : _lists[i]['规格参数（容量、支数、大小)/Specification'],
          UserSKUCode: _lists[i]['用户SKUCode/UserSKUCode'] == undefined ? '' : _lists[i]['用户SKUCode/UserSKUCode'],
          price: _lists[i]['常规监测价(日常到手价）低于此价格为破价'] == undefined ? '' : _lists[i]['常规监测价(日常到手价）低于此价格为破价'],
          email: JSON.parse(localStorage.getItem("email")).val          
        }
        _query.push(_obj)
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(_query),
        success: function() {
          that.$message({
            type: 'success',
            message: '批量导入成功'
          })
          that.cancelImport()
          that.getBaseinfo()
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

  }
}
</script>